import { rootApi } from '@/store/api'

export const apiMiddlewares = [rootApi.middleware]
